import * as constants from "./constants";

export const fetchMissingEnrolment = (data) => {
  return {
    type: constants.FETCH_MISSING_ENROLMENT,
    data,
  };
};

export const fetchMissingEnrolmentSuccess = (data) => {
  return {
    type: constants.FETCH_MISSING_ENROLMENT_SUCCESS,
    payload: data,
  };
};

export const fetchMissingEnrolmentError = (data) => {
  return {
    type: constants.FETCH_MISSING_ENROLMENT_ERROR,
    data: data,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_MISSING_ENROLMENT_MANAGER_STATE,
    data,
  };
};
